import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-24 md:py-32 overflow-hidden bg-background-50">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Hong%20Kong%20skyline%20at%20blue%20hour%20dusk%2C%20Victoria%20Harbour%2C%20IFC%20and%20ICC%20towers%20silhouette%2C%20dramatic%20dark%20navy%20sky%20with%20faint%20golden%20horizon%20glow%2C%20cinematic%20atmosphere%2C%20professional%20financial%20district%2C%20deep%20shadows%2C%20moody%20and%20powerful%2C%20no%20text%2C%20no%20people&width=1920&height=800&seq=cta-hk-dark-2026&orientation=landscape"
          alt="香港黄昏天际线"
          className="w-full h-full object-cover object-top opacity-50"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-background-50 via-background-50/80 to-background-50/30"></div>
      </div>

      {/* Data line accents */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none opacity-[0.04]">
        {[...Array(8)].map((_, i) => (
          <div
            key={i}
            className="absolute h-px bg-gradient-to-r from-transparent via-accent-400 to-transparent"
            style={{ top: `${15 + i * 11}%`, left: '5%', right: `${20 + i * 5}%` }}
          ></div>
        ))}
      </div>

      <div className="relative px-6 md:px-12 lg:px-20">
        <div className="max-w-[1400px] mx-auto">
          <div className="max-w-2xl">
            <p className="text-accent-500 text-xs md:text-sm font-semibold tracking-[0.25em] uppercase mb-4">Open Ecosystem</p>
            <h2 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-100 leading-tight mb-6">
              开放合作生态<br />
              <span className="bg-gradient-to-r from-accent-400 to-primary-300 bg-clip-text text-transparent">共建科技金融未来</span>
            </h2>
            <p className="text-sm md:text-base text-foreground-400 leading-relaxed mb-10 max-w-xl font-light">
              我们与全球顶尖金融机构、科技企业与专业服务机构建立深度合作，共同推动量化投资、资产管理与金融科技的创新发展。期待与您携手，创造长期价值。
            </p>
            <Link
              to="/cooperation"
              className="group inline-flex items-center gap-2.5 px-8 py-3.5 bg-accent-500 text-background-950 font-bold text-sm rounded-full hover:bg-accent-400 transition-all duration-300 whitespace-nowrap shadow-[0_0_30px_rgba(200,160,80,0.12)] hover:shadow-[0_0_40px_rgba(200,160,80,0.2)]"
            >
              <i className="ri-shake-hands-line text-lg"></i>
              探索合作
              <i className="ri-arrow-right-up-line group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform duration-300"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}